import type { OfferWithSanitizedLocations } from '@ocx/data-offers';
import { OfferDetailsAvailableAtLocation } from '@ocx/ui-offers';
import { calculateDistance, Coordinates } from '@ocx/utils';

export const getAvailableAtLocations = (
  offer: OfferWithSanitizedLocations | null,
  memberCoordinates: Coordinates | null,
): OfferDetailsAvailableAtLocation[] => {
  if (!offer) {
    return [];
  }

  const locations: OfferDetailsAvailableAtLocation[] = offer.availableAtLocations.map<OfferDetailsAvailableAtLocation>(
    (location) => ({
      uuid: location.uuid,
      name: location.name || location.address.street1,
      address: `${location.address.street1}, ${location.address.city}, ${location.address.state}`,
      coordinates: { lat: location.address.geoLocation.latitude, lng: location.address.geoLocation.longitude },
    }),
  );

  if (memberCoordinates) {
    locations.sort((a, b) => {
      const distanceToA = calculateDistance(memberCoordinates, a.coordinates);
      const distanceToB = calculateDistance(memberCoordinates, b.coordinates);
      return distanceToA - distanceToB;
    });
  }

  return locations;
};
